import axios from "axios";
import Vue from "vue";
import i18n from "@/i18n";
import Store from "@/services/store";
import Router from '@/services/router';

Vue.use(Vue2Storage);
const devHeaders = process.env.VUE_APP_DEV_HEADER;
const lionheartBaseUrl = process.env.VUE_APP_LIONHEART_API_URL;
const braveheartBaseUrl = process.env.VUE_APP_BRAVEHEART_BASE_URL;
const mrsBaseUrl = process.env.VUE_APP_MRS_API_URL;
const useBraveheart = process.env.VUE_APP_USE_BRAVEHEART;
const specialRoutesString = process.env.VUE_APP_SPECIAL_ROUTES;
const lionheart = axios.create({
   baseURL: `${lionheartBaseUrl}/api`,
   withCredentials: false,
})

const mrsApi = axios.create({
   baseURL: `${mrsBaseUrl}/api`,
   withCredentials: false,
})

function applySpecialRoute(config, baseUrl) {
   const {method, url} = config;
   let specialRoutes = [];

   try {
      specialRoutes = JSON.parse(specialRoutesString).routes;
   } catch (e) {
      console.warn('specialRoutes is invalid.');
   }
   
   let routeMatched = false;

   for (const specialRoute of specialRoutes) {
      const methodMatched = method.toLowerCase() == specialRoute.method.toLowerCase();
      
      if (methodMatched) {
         if (specialRoute.type == 'string') {
            if (url.trim() == specialRoute.path.trim()) {
               routeMatched = true;
               break;
            }
         } else if (specialRoute.type == 'regex') {
            const pattern = new RegExp(specialRoute.path);
            if (pattern.test(url)) {
               routeMatched = true;
               break;
            }
         }
      }
   }

   let newconfig = config;

   if (routeMatched) newconfig['baseURL'] = `${baseUrl}/api`;

   return newconfig;
}

let auth_key = "auth",
   login_path = "/login";

if (location.href.includes("admin")) {
   auth_key = "auth_admin";
   login_path = "/admin/login";
}
lionheart.interceptors.request.use(
   (config) => {
      Store.commit("checkin-site/loading", true);
      config.headers["Lang"] = `${i18n.locale}`;

      if (devHeaders) {
         config.headers[devHeaders] = true;
      }

      if (Vue.$storage.has(auth_key)) {
         config.headers["Authorization"] = `Bearer ${Vue.$storage.get(auth_key).token}`;
      }

      if (useBraveheart) return applySpecialRoute(config, braveheartBaseUrl);

      return config;
   },

   (error) => {
      return Promise.reject(error);
   }
);

// Response
lionheart.interceptors.response.use(
   (response) => {
      try {
         // if (response.data && response.data.data.access_token) {
         //     //auto refresh auth token when change on each request
         //     localStorage.setItem('auth', JSON.stringify(response.data.data));
         // }
      } catch (e) {
         console.info(e);
      }
      Store.commit("checkin-site/loading", false);
      return response;
   },
   (error) => {
      let maintenancePage = Router.resolve({ name: 'checkin-maintenance' }).href;
      let pageNotFound = Router.resolve({ name: '404' }).href;
      let loginPage = Router.resolve({ name: 'checkin-facility-login' }).href;

      let contentType = error.response.headers['content-type'] ?? null;
      let errorMessage = null;

      if (contentType == 'application/json') {
         let extractedErrorMessage = null;
         if (error.response.data instanceof ArrayBuffer) {
            const text = new TextDecoder('utf-8').decode(error.response.data); 
            try {
               extractedErrorMessage = JSON.parse(text).message;
            } catch (e) {
               extractedErrorMessage = null;
            }
         } else {
            try {
               extractedErrorMessage = JSON.parse(error.response.data).message;
            } catch (e) {
               extractedErrorMessage = null;
            }
         }
         errorMessage = extractedErrorMessage;
      }

      let status;
      try {
         status = error.response.status;
      } catch (e) {
         status = error;
      }

      /* 
      * Impose no generic redirection for error response with message body to be handled instead by the receiving page UI.
      */
      if (errorMessage == null) {
         if (status === 503) {
            window.location.href = maintenancePage;
            return;
         }

         if (status === 401) {
            Vue.$storage.remove(auth_key);
            window.location.href = loginPage;
            return;
         }

         if (status === 404) {
            Vue.$storage.remove(auth_key);
            window.location.href = pageNotFound;
            return;
         }
      }

      const settlementRoutes = [
         "checkin-facility-dashboard-home",
         "checkin-facility-dashboard-reservation-list",
         "checkin-facility-dashboard-visitor-payments-settlement",
         "checkin-facility-dashboard-visitor-payments-payout",
         "checkin-facility-dashboard-downloads",
         "checkin-facility-dashboard-visitor-traction"
      ]
      const currentRouteName = Router.currentRoute.name;
      errorMessage = i18n.t("error-messages.default-message");
      if (settlementRoutes.includes(currentRouteName) ){
         errorMessage = i18n.t("error-messages.load-list");
      }
      
      if (Number.isInteger(status) === false || status >= 500) {
         Vue.$toast.error(`${errorMessage} Status: [${status}]`, {
            position: "top",
            duration: 3000,
         });
      }

      Store.commit("checkin-site/loading", false);

      return Promise.reject(error);
   }
);

Vue.prototype.$lionheart = lionheart;
Vue.prototype.$mrsApi = mrsApi; 

export { lionheart, mrsApi };
